import React, { useState, useEffect, useContext } from 'react';
import { useRemote } from '../../../../Utils/Utils';
import { useParams, useHistory } from 'react-router-dom';
import { FundContext } from '../FundPage';
import { FileText } from 'react-feather';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import DetailTextbox from '../DetailTextbox'
import FlexWrapper from '../../../FlexWrapper';
import Checkbox from '../../../../components/Checkbox';
import Modal from '../../../../components/Modals/Modal';
import Tooltip from '../../../../components/popups/Tooltip';
import DetailSectionHeader from '../../../Shared/DetailSection/DetailSectionHeader';
import "../FundPage.scss"


const FundFootnotes = ({ portfolio }) => {
    const { fundId } = useParams()
    const { fund, setFund, editMode, setEditMode, setSelectedTab, taggedNotesToDelete, setTaggedNotesToDelete, notes, setNotes, taggedNotesIds, setTaggedNotesIds, setTaggedNotes, templatesWithTaggedNotes, setTemplatesWithTaggedNotes } = useContext(FundContext)
    const remote = useRemote()
    const identifier = btoa(fundId)
    const history = useHistory()

    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        setSelectedTab("Footnotes")
        if (fund) {
            setNotes(fund.disclosures)
            remote.get(`/retrieve/${identifier}/data?key=FOOTNOTES`).then((res) => {
                checkTaggedNotes(res)
            })
            // remote.get("/retrievev2/" + identifier + "/Simplicity QFU").then((res) => checkTaggedNotes(res))
        }
    }, [fund])

    function updateNote(boolean, id) {
        const newList = notes.map(note => {
            if (note.id === id) {
                const updatedNote = { ...note, selected: boolean }
                return updatedNote
            } else return note
        })
        setNotes(newList)
        setFund({ ...fund, disclosures: newList })
    }

    function checkTaggedNotes(res) {
        res && res.map(r => {
            if (r.data && r.data["FOOTNOTES"]) {
                const parsedNotes = JSON.parse(r.data["FOOTNOTES"])
                const taggedNotesArray = parsedNotes && parsedNotes.length > 0 && parsedNotes.map(n => n.offerNoteId)
                setTaggedNotes(parsedNotes)
                setTaggedNotesIds(taggedNotesArray)

                if (templatesWithTaggedNotes.length > 0 && !templatesWithTaggedNotes.includes(r.template) && parsedNotes.length > 0) {
                    setTemplatesWithTaggedNotes([...templatesWithTaggedNotes, r.template])
                } else if (templatesWithTaggedNotes.length === 0 && parsedNotes.length > 0) {
                    setTemplatesWithTaggedNotes([r.template])
                }
            }
        })
    }

    function disclosureList(data) {
        if (data?.length > 0) {
            const hasSelected = data.find(n => n.selected)
            if (!hasSelected && !editMode) {
                return <p>No notes selected for this fund. <span className='text-link' onClick={() => setEditMode(true)}>Select some notes</span></p>
            } else {
                return data.map(note => {
                    const { disclosure, id, selected } = note
                    const isTagged = taggedNotesIds && taggedNotesIds.length > 0 && taggedNotesIds.includes(id)
                    return (
                        (editMode || (!editMode && selected)) &&
                        <PageGridItem container direction='row' gap='s' alignItems='center' style={{ paddingBottom: '1rem' }}>
                            {editMode &&
                                <FlexWrapper direction="column" style={{ height: "100%", width: 24 }}>
                                    <Checkbox checked={selected}
                                        onChange={() => {
                                            if (isTagged && selected) {
                                                setTaggedNotesToDelete(taggedNotesToDelete && taggedNotesToDelete.length > 0 ? [...taggedNotesToDelete, id] : [id])
                                                setShowModal(true)
                                            } else if (isTagged && !selected) {
                                                updateNote(true, id)
                                                const filteredList = taggedNotesToDelete.filter(n => n.offerNoteId !== id)
                                                setTaggedNotesToDelete(filteredList)
                                            } else updateNote(!selected, id)
                                        }}
                                        className="delete-icon no-margin"
                                    />
                                    {isTagged && selected &&
                                        <Tooltip placement="left" label="Note in use">
                                            <span className={`material-symbols-outlined disclosure-pin-icon pinned-note`} >keep</span>
                                        </Tooltip>
                                    }
                                </FlexWrapper>
                            }
                            <DetailTextbox
                                value={disclosure}
                                update={() => null}
                                editMode={false}
                                placeholder={'Add notes'}
                                minHeight={50}
                                resize='vertical'
                                className='box-style'
                                boxStyle
                                fullWidth
                                divClassName={!selected ? 'no-selected-box' : null}
                            />
                        </PageGridItem>
                    )
                })
            }
        }
    }

    return (
        <>
            <PageGridItem container col="1 / span 6" gap='l' direction='col'>
                <DetailSectionHeader header="Footnotes" icon={<FileText />} />
                <div>
                    {
                        <>
                            {notes?.length === 0 ? <p>No notes found on offer {fund?.offerNumber}. <span onClick={() => history.push(portfolio ? '/admin/portfolio-management/products/' + fund?.offerNumber + "/footnotes/" : '/admin/fund-management/offers/' + fund?.offerNumber)} className='text-link' href=''>Add some notes</span></p> : ""}
                            {disclosureList(notes)}
                        </>
                    }
                </div>
            </PageGridItem>
            {showModal && <Modal
                header="Are you sure?"
                cancelButton={{ onClick: () => { setShowModal(false); setTaggedNotesToDelete([]) } }}
                confirmButton={{ onClick: () => { setShowModal(false); updateNote(false, taggedNotesToDelete[taggedNotesToDelete.length - 1]) } }}
            >
                <p>This note is currently in use and will be removed from any templates using it once your changes are saved.</p>
            </Modal>}
        </>
    );
}

export default FundFootnotes;